<template>
  <div>
    <!-- 顶部搜索栏 -->
    <el-row>
      <el-col :xs="24" :sm="24" :lg="24">
        <div class="pad-container flx-row ali-c">
          <el-input
            placeholder="菜品名"
            class="search-input ml-10"
            v-model="form.goodsName"
          ></el-input>
          <el-select
            placeholder="请选择门店"
            class="search-input ml-15"
            v-model="form.storeId"
          >
            <el-option
              v-for="(item, index) in store_list"
              :key="index"
              :label="item.storeName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.merchantId"
            filterable
            placeholder="请选择商户"
            class="search-input ml-15"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.merchantId"
              :label="item.merchantName"
              :value="item.merchantId"
            >
            </el-option>
          </el-select>
          <el-input
            clearable
            placeholder="请输入手机号"
            class="search-input ml-10"
            v-model="form.phone"
          ></el-input>
          <el-date-picker
            class="ml-10"
            v-model="time"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00','23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="ml-10"
            @click="getList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" class="ml-10" @click="reset"
            >重置</el-button
          >
        </div>
      </el-col>
    </el-row>
    <!-- 表格内容 -->
    <el-row class="mt-24">
      <el-col el-col :xs="24" :sm="24" :lg="24">
        <div class="pad-container">
          <el-table class="mt-24 member-table" :data="tableData">
            <el-table-column
              label="餐饮团购核销码"
              prop="qrCode"
            ></el-table-column>
            <el-table-column
              label="商户名称"
              prop="merchantName"
            ></el-table-column>
            <el-table-column label="手机号码" prop="phone"></el-table-column>
            <el-table-column label="所属门店">
              <template slot-scope="scope">
                {{ scope.row.storeName ? scope.row.storeName : "--" }}
              </template>
            </el-table-column>
            <el-table-column label="菜品名" prop="goodsName">
              <template slot-scope="scope">
                <div v-for="(item, key) in scope.row.goodsList" :key="key">
                  <span v-if="key < scope.row.goodsList.length - 1"
                    >{{ item.goodsName }},</span
                  >
                  <span v-else>{{ item.goodsName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="核销人员"
              prop="offsetPeopleName"
            ></el-table-column>
            <el-table-column
              label="核销时间"
              prop="offsetTime"
            ></el-table-column>
          </el-table>
          <div class="flx-row ali-c js-c mt-24">
            <Pagination
              :total="total"
              :pageNum="form.pageNum"
              :pageSize="form.pageSize"
              :pageSizes="[10, 20, 30, 50, 100]"
              @changePage="changePage"
              @syncPageData="syncPageData"
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import {
  queryCateringOffset,
  listOfPage2,
  queryMerchantAll
} from "@/api/verify_center/verify_records";
export default {
  components: { Pagination },
  data() {
    return {
      // 顶部搜索栏数据
      form: {
        merchantId: "", //	string	false	普通参数		商户id
        storeId: "", //	string	false	普通参数		门店id
        phone: "", //	string	false	普通参数		手机号
        startTime: "", //	string	false	普通参数		开始时间
        endTime: "", //	string	false	普通参数		结束时间
        pageNum: 1, //	string	true	普通参数	1
        pageSize: 10, //	string	true	普通参数	10
        goodsName:''//菜品名
      },
      store_list: [], //门店列表
      merchantList: [], //商户列表
      // 优惠券表格数据内容
      tableData: [],
      // 会员-当前分页与总条数
      total: 0,
      time: [],
    };
  },
  mounted() {
    this.getlistOfPage2();
    this.getList();
    this.getQueryMerchantAll()
  },
  methods: {
    // 初始化数据
    getList() {
      if (this.time.length) {
        this.form.startTime = this.time[0];
        this.form.endTime = this.time[1];
      }
      queryCateringOffset(this.form).then((res) => {
        this.tableData = res.data.body.list;
        this.total = res.data.body.total;
      });
    },
    // 重置搜索关键词
    reset() {
      this.form = {
        merchantId: "", //	string	false	普通参数		商户id
        storeId: "", //	string	false	普通参数		门店id
        phone: "", //	string	false	普通参数		手机号
        startTime: "", //	string	false	普通参数		开始时间
        endTime: "", //	string	false	普通参数		结束时间
        pageNum: 1, //	string	true	普通参数	1
        pageSize: 10, //	string	true	普通参数	10
      };
      this.time = [];
      this.getList();
    },
    // 获取门店列表
    getlistOfPage2() {
      listOfPage2().then((res) => {
        this.store_list = res.data.body;
      });
    },
    changePage(type) {
      this.form.pageSize = type.size;
      this.getList();
    },
    syncPageData(data) {
      this.form.pageNum = data.num;
      this.getList();
    },
    getQueryMerchantAll(){
      queryMerchantAll({}).then(res=>{
        this.merchantList=res.data.body;   
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.member-table {
  .circle {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
}
</style>
